import type { IconProps } from "@/types/IconProps";

export function Location(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12 6.201 22.5 12 22.5V24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12v-1.5c5.799 0 10.5-4.701 10.5-10.5"></path>
      <g clipPath="url(#clip0_28_168)">
        <path d="M16.25 10.75a4.25 4.25 0 0 0-4.04-4.245L12 6.5a4.25 4.25 0 0 0-4.25 4.25c0 1.307.74 2.734 1.723 4.026.903 1.188 1.937 2.16 2.527 2.678.59-.518 1.624-1.49 2.527-2.678.984-1.292 1.723-2.719 1.723-4.026m-3.125 0a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0m1.5 0a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0m3.125 0c0 1.813-.991 3.572-2.03 4.935-1.055 1.387-2.254 2.49-2.854 3.007l-.04.032c-.208.156-.456.25-.715.271L12 19c-.298 0-.588-.097-.826-.276q-.02-.015-.04-.032c-.6-.518-1.8-1.62-2.855-3.007-1.038-1.363-2.029-3.122-2.029-4.935A5.75 5.75 0 0 1 12 5l.285.007a5.75 5.75 0 0 1 5.465 5.743"></path>
      </g>
      <defs>
        <clipPath id="clip0_28_168">
          <path fill="#fff" d="M4.5 4.5h15v15h-15z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
